/** @format */

import React, { useState } from 'react'

import moment from 'moment'

import { Form, Select } from 'antd'

import './style.scss'
const { Option } = Select

const HomeDeliverySchedule = (props) => {
	console.log('props DeliverySchedule', props)
	const [form] = Form.useForm()
	const [timers, setTimers] = useState([])

	// Obtener schedule y special_schedule de la farmacia
	const pharmacyData = props.order.info.pharmacy[0]
	const specialSchedule = pharmacyData.special_schedule ? pharmacyData.special_schedule : []
	
	let regularSchedule
	const activeOverride = specialSchedule.find((sch) => sch && sch.status === true)

	if (activeOverride && activeOverride.original_daily_schedules) {
		regularSchedule = activeOverride.original_schedule
	} else {
		regularSchedule = pharmacyData.schedule ?? []
	}

	const getAvailableDateRanges = (count = 7) => {
		const closedSet = {}

		for (let s = 0; s < specialSchedule.length; s++) {
			const sch = specialSchedule[s]
			if (!sch?.applies_to_days?.length) continue
			if (!sch.reason?.includes('Cerrado')) continue

			const startDay = moment.unix(sch.start).utc().startOf('day')
			const endDay = moment.unix(sch.end).utc().startOf('day')

			for (let d = moment(startDay); d.diff(endDay) <= 0; d.add(1, 'days')) {
				closedSet[d.format('DD/MM/YYYY')] = true
			}
		}

		const closedWeekdays = new Set()
		regularSchedule.forEach((r) => {
			if (typeof r.open === 'string' && r.open.toUpperCase() === 'CERRADO') {
				closedWeekdays.add(Number(r.day))
			}
		})

		const isBusinessOpenDay = (dayMoment) => {
			const formatted = dayMoment.format('DD/MM/YYYY')
			const weekDayNum = dayMoment.day()

			if (weekDayNum === 0 || weekDayNum === 6) return false
			if (closedSet[formatted]) return false
			if (closedWeekdays.has(weekDayNum)) return false

			return true
		}

		const addBusinessDays = (fromDate, businessDays) => {
			let d = fromDate.clone()
			let added = 0
			while (added < businessDays) {
				d.add(1, 'day')
				if (isBusinessOpenDay(d)) {
					added++
				}
			}
			return d
		}

		const now = moment()
		const orderDay = now.clone().startOf('day')
		const weekday = orderDay.day()

		const provider = props.order.shipping_information?.delivery_provider
		const isPharolGo = typeof provider === 'string' && provider.toLowerCase() === 'pharolgo'

		const baseBusinessDays = isPharolGo ? 2 : 3

		const cutoffHour = 15
		const isAfterCutoff = now.hour() >= cutoffHour
		const isWeekend = weekday === 0 || weekday === 6

		let startDate = orderDay.clone()

		if (isWeekend) {
			startDate = addBusinessDays(orderDay, 1)
		} else if (isAfterCutoff) {
			startDate = addBusinessDays(orderDay, 1)
		}

		let firstDeliveryDay = addBusinessDays(startDate, baseBusinessDays)

		const ranges = []
		let currentStart = firstDeliveryDay.clone()

		while (ranges.length < count) {
			if (!isBusinessOpenDay(currentStart)) {
				currentStart = addBusinessDays(currentStart, 1)
				continue
			}

			const currentEnd = addBusinessDays(currentStart, 1)

			ranges.push({
				start: currentStart.format('DD/MM/YYYY'),
				end: currentEnd.format('DD/MM/YYYY'),
			})

			currentStart = currentEnd.clone()
		}

		return ranges
	}

	const dateRanges = getAvailableDateRanges()

	const handleDateSelected = (value) => {
		console.log('Selected date:', value)
		
		// Limpiar timers y time seleccionado
		setTimers([])
		props.setInfoSelected((pvSt) => ({
			...pvSt,
			date: value,
			time: '',
		}))
		form.setFieldsValue({
			time_delivery: null,
		})

		// Obtener la fecha de inicio del rango seleccionado (formato "DD/MM/YYYY - DD/MM/YYYY")
		const startDateStr = value.split(' - ')[0]
		const selected = moment(startDateStr, 'DD/MM/YYYY')
		const weekday = selected.day()
		const isToday = selected.isSame(moment(), 'day')
		const now = moment()

		const activeOverrideForDate = specialSchedule.find((sch) => sch?.status === true)
		const sourceDaily = activeOverrideForDate ? activeOverrideForDate.original_schedule : regularSchedule

		const daily = sourceDaily?.find((d) => Number(d.day) === weekday) ?? null

		const dateOverride = specialSchedule.find((sch) => {
			if (sch?.reason !== 'Cambio de Horario' && sch?.reason !== 'Farmacia de turno') {
				return false
			}
			const selectedDayUTC = selected.clone().utc().startOf('day')
			const startDayUTC = moment.unix(sch.start).utc().startOf('day')

			const endUTC = moment.unix(sch.end).utc()
			const isMidnight = endUTC.hours() === 0 && endUTC.minutes() === 0 && endUTC.seconds() === 0

			const endDayExclusiveUTC = isMidnight ? endUTC.startOf('day') : endUTC.clone().add(1, 'day').startOf('day')

			return selectedDayUTC.isSameOrAfter(startDayUTC) && selectedDayUTC.isBefore(endDayExclusiveUTC)
		})

		let openStr, closeStr

		if (dateOverride && dateOverride.override_open && dateOverride.override_close) {
			openStr = dateOverride.override_open
			closeStr = dateOverride.override_close
		} else if (daily) {
			openStr = daily.open
			closeStr = daily.close
		} else {
			setTimers([])
			return
		}

		if (!openStr || !closeStr || openStr.toUpperCase() === 'CERRADO' || closeStr.toUpperCase() === 'CERRADO') {
			setTimers([])
			return
		}

		const openM = moment(openStr, 'HH:mm:ss')
		const closeM = moment(closeStr, 'HH:mm:ss')

		if (!openM.isValid() || !closeM.isValid() || !openM.isBefore(closeM)) {
			setTimers([])
			return
		}

		const newTimers = []
		let cur = openM.clone()

		while (cur.isBefore(closeM)) {
			const blockStart = cur.clone()
			const blockFinish = cur.clone().add(1, 'hour')

			if (!isToday || blockStart.isAfter(now)) {
				newTimers.push({
					start: blockStart.format('HH:mm'),
					finish: blockFinish.format('HH:mm'),
				})
			}
			cur.add(1, 'hour')
		}

		setTimers(newTimers)
	}

	const handleTimeSelected = (value) => {
		props.setInfoSelected((pvSt) => ({
			...pvSt,
			time: value,
		}))
	}

	return (
		<Form form={form} className='ph-objected-recipe-input-global-container'>
			<Form.Item
				name='date_delivery'
				rules={[
					{
						required: true,
						message: 'Ingrese la fecha de entrega',
					},
				]}>
				<Select
					placeholder='Día y Fecha'
					className='ph-objected-recipe-delivery-selector'
					size='large'
					onChange={(value) => handleDateSelected(value)}>
					{dateRanges.map((range, index) => (
						<Option value={`${range.start} - ${range.end}`} key={index}>
							{`${range.start} - ${range.end}`}
						</Option>
					))}
				</Select>
			</Form.Item>
			{timers.length > 0 && (
				<Form.Item
					name='time_delivery'
					rules={[
						{
							required: true,
							message: 'Ingrese el horario de entrega',
						},
					]}>
					<Select
						placeholder='Horario'
						className='ph-objected-recipe-delivery-hour-selector'
						size='large'
						onChange={(value) => handleTimeSelected(value)}>
						{timers.map((element, index) => (
							<Option value={`${element.start} - ${element.finish}`} key={index}>
								{`${element.start} - ${element.finish}`}
							</Option>
						))}
					</Select>
				</Form.Item>
			)}
		</Form>
	)
}
export default HomeDeliverySchedule
